import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var TinderColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M3.573 20.789c1.32-.455 1.544-1.64 1.376-2.729 0-.039.033-.067.067-.05 1.263.612 2.683 1.953 2.683 3.974 0 1.55-1.201 2.92-2.947 2.92-1.863 0-2.947-1.331-2.947-2.92 0-.926.657-1.88 1.364-2.284.034-.023.079 0 .079.039.017.207.073.735.303 1.044.005.006.017.006.022.006Z",
    svgColor: "url(#a)"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m11.413 23.68.1-.114.296.947-.038.036c-.223.209-.558.315-.996.315h-.016c-.393 0-.7-.107-.913-.318-.218-.216-.328-.532-.328-.94v-2.565H8.76v-1.044h.758v-1.252h1.168v1.252h.926v1.044h-.932v2.318c0 .107.026.455.354.455.165 0 .322-.068.38-.134Zm.793 1.077v-4.754h1.167v4.754h-1.167Zm.578-6.69a.703.703 0 1 1-.702.7c0-.386.321-.7.702-.7Zm3.857 1.823c1.01 0 1.566.553 1.566 1.555v3.312h-1.168V21.72h.004c-.024-.538-.284-.78-.835-.78-.49 0-.891.297-1.094.561v3.256h-1.168v-4.754h1.168v.502c.338-.32.877-.614 1.527-.614Zm5.394.608v-2.235h1.168v6.5h-1.168v-.493c-.372.383-.866.6-1.386.6-1.273 0-2.128-1-2.128-2.487 0-1.488.855-2.492 2.128-2.492.523 0 1.017.218 1.386.607Zm0 1.002c-.23-.326-.689-.56-1.1-.56-.722 0-1.207.58-1.207 1.443 0 .863.485 1.437 1.207 1.437.42 0 .879-.23 1.1-.548V21.5Zm3.84-1.61c1.378 0 2.34 1.062 2.34 2.583v.32h-3.529c.117.668.642 1.094 1.363 1.094.456 0 .955-.193 1.242-.48l.072-.072.553.799-.052.05c-.46.442-1.14.685-1.916.685-1.464 0-2.487-1.024-2.487-2.492.006-1.418 1.044-2.487 2.414-2.487Zm-1.197 2.027h2.398c-.066-.717-.659-1.044-1.201-1.044-.82 0-1.13.618-1.197 1.044Zm6.36-2.021h.085v1.175l-.1-.02a1.554 1.554 0 0 0-.299-.027c-.376 0-.899.264-1.094.548v3.18h-1.168v-4.75h1.174v.533c.386-.404.897-.639 1.403-.639Z",
    svgColor: "#111418"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M32.72 20.339a.629.629 0 0 1 .57-.431h8.798c.248 0 .394.193.326.43l-1.117 3.928a.629.629 0 0 1-.572.432h-8.797c-.248 0-.394-.194-.326-.432l1.117-3.927Z",
    svgColor: "url(#b2)"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M34.276 23.222c.34 0 .606-.14.797-.353v-.719h-.892v.348h.494v.225a.63.63 0 0 1-.399.143c-.34 0-.586-.261-.586-.615s.247-.615.586-.615c.2 0 .36.113.443.245l.332-.18a.875.875 0 0 0-.775-.418c-.547 0-.996.376-.996.968s.449.971.996.971Zm2.001-.003c-.564 0-.977-.404-.977-.968s.413-.968.977-.968c.564 0 .98.404.98.968s-.413.968-.98.968Zm0-.353c.345 0 .57-.267.57-.615s-.224-.615-.57-.615c-.345 0-.567.264-.567.615s.222.615.567.615Zm2.45.32v-.351h-.791v-1.521h-.399v1.872h1.19Zm1.016 0h-.738v-1.872h.738c.587 0 .994.373.994.937 0 .564-.407.935-.994.935Zm0-.351c.37 0 .587-.267.587-.584 0-.317-.202-.586-.587-.586h-.34v1.17h.34Z",
    svgColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.97 18.14a.63.63 0 0 0-.641.622c0 .346.284.63.641.63a.628.628 0 0 0 .638-.63.62.62 0 0 0-.638-.623Zm.004 1.12a.482.482 0 0 1-.486-.498c0-.277.205-.497.482-.497s.479.224.479.5c0 .278-.202.494-.475.494Zm.14-.479v-.007c.077-.023.13-.076.13-.145 0-.06-.027-.11-.061-.136-.046-.027-.099-.046-.216-.046-.103 0-.183.008-.24.02v.622h.145v-.25h.068c.08 0 .118.03.129.098.019.072.03.129.05.152h.155a.473.473 0 0 1-.046-.156c-.019-.084-.053-.129-.114-.152Zm-.17-.045h-.069v-.179a.344.344 0 0 1 .08-.007c.091 0 .133.038.133.095 0 .064-.065.09-.144.09Z",
    svgColor: "url(#c)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.607,
    y1: 18.121,
    x2: 8.416,
    y2: 23.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E9AA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D37C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2",
    x1: 31.479,
    y1: 19.849,
    x2: 35.021,
    y2: 27.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E9AA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D37C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 41.329,
    y1: 18.766,
    x2: 42.608,
    y2: 18.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E9AA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D37C"
  }))));
});
TinderColor.displayName = 'TinderColor';
TinderColor.defaultProps = {
  'aria-label': 'TinderColor'
};
export default TinderColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/TinderColor.js
// module id = 3587
// module chunks = 11